export const last = (value:Array<any>, index=-1) => value[value.length+index];